// Вид карточек ленты. 'compact' — упрощённый masonry (по умолчанию, см. Фазу C
// упрощения), 'full' — прежний богатый вид с кнопками действий. Хранится в
// users.card_view, синхронизируется между устройствами.

export type CardView = 'compact' | 'full';

export const DEFAULT_CARD_VIEW: CardView = 'compact';

/** Нормализует сырое значение из БД/запроса. Всё, кроме явного 'full', → compact. */
export function parseCardView(raw: unknown): CardView {
  return raw === 'full' ? 'full' : 'compact';
}
